<div class="wrapper">
  <div class="profile-info">
    <app-user-avatar
      [isActive]="false"
      [bounsCount]="bounsCount"
      [avatarImgSrc]="userInfo?.avater || ''"
      [currentVipLevel]="currentVipLevel"
      [isSuperVip]="isSuperVip"
    />

    <div class="wrap">
      <div class="user-name">{{ userName }}</div>
      <div class="redirect-button" (click)="jumpToPage('settings/profile')">
        My Profile<i class="icon fi-cheveron-right"></i>
      </div>
    </div>
  </div>

  <app-progress-bar [isLeftMenu]="true"></app-progress-bar>

  <cs-button (buttonClick)="jumpToPage('bonuses')" [label]="'My bonuses'" [color]="'primary'" [size]="'small'" />
</div>
